import { render, staticRenderFns } from "./bodyAssemblaggio.vue?vue&type=template&id=46f7f8c2&scoped=true"
import script from "./bodyAssemblaggio.vue?vue&type=script&lang=js"
export * from "./bodyAssemblaggio.vue?vue&type=script&lang=js"
import style0 from "./bodyAssemblaggio.vue?vue&type=style&index=0&id=46f7f8c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f7f8c2",
  null
  
)

export default component.exports